import { reduce, set, pick } from "lodash"
import { buildContributorKey } from "./contributors"
import { computeGroupsMap } from "./assets"

function extractContributorMarginalContribution(contributor) {
  return {
    marginal: {
      total: contributor.exposureRiskCorrelation,
      ...pick(contributor.attribution.exposureRiskCorrelation, ["specific", "factors"]),
    },
  }
}

export function computeMarginalContributionMap(marginalContributionContributors, groupedMarginalContributionContributors, groupingOptions) {
  const contributors = !groupingOptions ? marginalContributionContributors : groupedMarginalContributionContributors
  return reduce(contributors, (acc, contributor) =>
    set(acc, buildContributorKey(contributor), extractContributorMarginalContribution(contributor)), {})
}

export function computeGroupedMarginalContributionMap(groups) {
  return computeGroupsMap(groups, { mapFn: extractContributorMarginalContribution })
}
